mainApp.component('fieldsSidePanel', {
    templateUrl: '/public/components/discovery/fields-side-panel.component.html',
    bindings: {
        fields: '<',
        fieldUsagesFetcher: '&',
        fieldsCardinality: '<',
        fieldsSpec: '<',
        selectedFields: '<',
        valueFormatter: '&',
        onColumnAdd: '&',
        onColumnRemove: '&',
        onAddFilter: '&',
        onFetchUsages: '&',
    },
    controller: function() {
        const ctrl = this;

        ctrl.$onChanges = function(changes) {
            if (changes['fieldsSpec'] && changes['fieldsSpec'].currentValue) {
                if (changes['fieldsCardinality'] && changes['fieldsCardinality'].currentValue) {
                    ctrl.fieldsArr = ctrl.getFieldsArray(changes['fieldsSpec'].currentValue, changes['fieldsCardinality'].currentValue, null);
                } else {
                    if (ctrl.fields) {
                        ctrl.fieldsArr = ctrl.getFieldsArray(changes['fieldsSpec'].currentValue, ctrl.fields);
                    } else {
                        ctrl.fieldsArr = ctrl.getFieldsArray(changes['fieldsSpec'].currentValue, {fieldToUsages: {}});
                    }
                }
            } else if (changes['fieldsCardinality'] && changes['fieldsCardinality'].currentValue) {
                if (ctrl.fieldsSpec) {
                    ctrl.fieldsArr = ctrl.getFieldsArray(ctrl.fieldsSpec, changes['fieldsCardinality'].currentValue, null);
                }
            }
        }

        ctrl.getFieldsArray = function(spec) {
            const result = [];
            _.forOwn(spec, function(value, key) {
                if (key === 'event_data')
                    return;

                result.push(key);
            });
            return result;
        }

        ctrl.isSelectedField = function(field) {
            return ctrl.selectedFields.includes(field);
        }

        ctrl.isPopularField = function(field) {
            return ctrl.fieldsSpec[field].popular;
        }

        ctrl.isVisibleField = function(field) {
            return typeof ctrl.fieldsCardinality === 'undefined' || typeof ctrl.fieldsCardinality[field] === 'undefined' || ctrl.fieldsCardinality[field] > 0;
        }

        ctrl.addColumn = function(field) {
            ctrl.onColumnAdd({field: field});
        }

        ctrl.removeColumn = function(field) {
            ctrl.onColumnRemove({field: field});
        }

        ctrl.addFilter = function(field, operator, value) {
            ctrl.onAddFilter({field: field, operator: operator, value: value});
        }

        ctrl.formatValue = function(field, value) {
            return ctrl.valueFormatter({field: field, value: value});
        }

        ctrl.fetchUsages = function(field, amount) {
            ctrl.onFetchUsages({field: field, amount: amount});
        }
    }
});